import { ReactElement } from 'react';

import { ChevronRightOutlined as ChevronRightOutlinedIcon } from '@mui/icons-material';
import { Theme, Box } from '@mui/material';

import { ListItemProps } from './types';

export default function ListItem(props: ListItemProps): ReactElement {
  const { label, color, hasChildren = false, isOpen = false, isChild = false } = props;

  return (
    <Box
      sx={{
        'cursor': 'pointer !important',

        'width': '100%',
        'minWidth': '136.41px',

        'display': 'flex',
        'flexDirection': 'row',
        'alignItems': 'center',
        'justifyContent': 'space-between',

        'backgroundColor': 'transparent',
        'color': 'black',
        'textDecoration': 'none',

        'typography': 'subtitle1',

        'p': 2,

        'transition': (theme: Theme) =>
          `${theme.transitions?.duration?.shortest}ms ${theme.transitions?.easing?.easeInOut}`,

        '& svg': {
          typography: 'h6',
          color: 'text.secondary',

          transition: (theme: Theme) =>
            `${theme.transitions?.duration?.shortest}ms ${theme.transitions?.easing?.easeInOut}`
        },

        '&:hover': {
          'backgroundColor': color && isChild ? `${color}.main` : 'grey.200',
          'textDecoration': 'none',
          'color': color && isChild ? 'white' : 'black',

          '& svg': {
            color: 'text.primary'
          }
        },

        '&:focus': {
          outline: 'transparent'
        }
      }}>
      {label}
      {hasChildren ? (
        <ChevronRightOutlinedIcon
          style={{
            transform: isOpen ? 'rotate(270deg)' : 'rotate(360deg)'
          }}
        />
      ) : null}
    </Box>
  );
}
